// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React from 'react';
import { _DevicePermissionDropdownStrings, _DevicePermissionDropdown, _DevicePermissionDropdownProps, ActiveErrorMessage, ErrorBarProps, _TroubleshootingGuideErrorBarStrings, _TroubleshootingGuideErrorBar, ErrorBar } from '@internal/react-components';
import { CallingHandlers } from '@internal/calling-component-bindings';
import { Common } from '@internal/acs-ui-common';

/**
 * @private
 */
export interface ConfigurationPageErrorBarProps {
  errorBarProps: {
    activeErrorMessages: ActiveErrorMessage[];
  } & Common<CallingHandlers, ErrorBarProps>;
  showTroubleShootingErrorBar?: boolean;
  onPermissionsTroubleshootingClick?: (permissionsState: {
    camera: PermissionState;
    microphone: PermissionState;
  }) => void;
  onNetworkingTroubleShootingClick?: () => void;
  permissionsState?: {
    camera: PermissionState;
    microphone: PermissionState;
  };
  onDismissError: (error: ActiveErrorMessage) => void;
}

/**
 * @private
 */
export const ConfigurationPageErrorBar = (props: ConfigurationPageErrorBarProps): JSX.Element => {
  const {
    errorBarProps
  } = props;
  return <ErrorBar {...errorBarProps} onDismissError={props.onDismissError} />;
};"../../../../../react-components/src""../../../../../calling-component-bindings/src""../../../../../acs-ui-common/src"